/**
 * Formatting Utilities
 * Helper functions for formatting dates, stats, and other data
 */

/**
 * Format stat type to human-readable label
 */
export const formatStatType = (statType) => {
  const labels = {
    bat_speed: 'Bat Speed',
    exit_velocity: 'Exit Velocity',
    launch_angle: 'Launch Angle',
    sprint_time: 'Sprint Time',
    pop_time: 'Pop Time',
    throwing_velocity: 'Throwing Velocity',
    pitching_velocity: 'Pitching Velocity',
    batting_average: 'Batting Average',
    home_runs: 'Home Runs',
    rbi: 'RBI',
    strikeouts: 'Strikeouts',
    era: 'ERA',
  };
  return labels[statType] || statType;
};

/**
 * Format date string to localized date
 */
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleDateString();
};

/**
 * Check if a drill is overdue
 */
export const isDrillOverdue = (dueDate, completed) => {
  if (completed || !dueDate) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(dueDate);
  due.setHours(0, 0, 0, 0);
  return due < today;
};
